import React from 'react'
import { Map } from 'immutable'
import PropTypes from 'prop-types'
import { compose } from 'recompose'
import ImmutablePropTypes from 'react-immutable-proptypes'
import Icon, { ICON_TYPES, ICON_STYLES } from 'components/Icon.v2'
import { TYPE_USER_PLAYLIST_ADD } from 'services/dialog'
import { connect as connectRedux } from 'react-redux'
import Button, { TYPES } from 'components/Button'
import UniqueId from 'components/UniqueId'
import { getBoundActions } from 'actions'
import ToolTip from 'components/ToolTip'
import {
  ADDED_TO_PLAY_LIST_GA4_EVENT,
  PLAYLIST_TILE_CTA_CLICKED_GA4_EVENT,
  REMOVED_FROM_PLAY_LIST_GA4_EVENT,
} from 'services/event-tracking'
import { PLAYLIST_TYPE_DEFAULT, PLAYLIST_TYPE_FAVORITES } from 'services/playlist'

class PlaylistAddRemove extends React.Component {
  //
  constructor (props) {
    super(props)
    this.state = {
      showAddRemoveIcon: false,
    }
  }

  onReturnFocus = () => {
    if (this.$el && this.$el.querySelector) {
      const btn = this.$el.querySelector('.button')
      if (btn) {
        btn.focus()
      }
    }
  }

  onModalSelect = (type, add, contentId, name, contentTitle) => {
    this.updatePlaylistItem(type, add, contentId, name, contentTitle)
  }

  /**
  * @param {MouseEvent} e
  * @return {void}
  */
  onClick = (e) => {
    e.preventDefault()
    e.stopPropagation()
    this.openUserPlaylistsModal()
    this.handleGa4EventsOnClick()
  }

  handleGa4EventsOnClick = () => {
    const { props } = this
    const { setDefaultGa4Event, ga4EventData = {} } = props
    setDefaultGa4Event(PLAYLIST_TILE_CTA_CLICKED_GA4_EVENT.mergeDeep(ga4EventData))
  }

  onRef = (el) => {
    this.$el = el
  }

  getLabel () {
    const { props } = this
    const {
      staticText, reverse, circlularIcon, noText,
    } = props

    const text = staticText.getIn(['data', 'addToPlaylist'])
    const type = ICON_TYPES.PLUS
    const icon = circlularIcon ? null : <Icon style={ICON_STYLES.OUTLINE} type={type} />
    const span = !noText ? <span className="playlist-add__label">{text}</span> : null
    return (
      <React.Fragment>
        { reverse ? span : icon }
        { reverse ? icon : span }
      </React.Fragment>
    )
  }

  getClass () {
    const { props } = this
    const {
      className, notext, reverse, circlularIcon,
    } = props
    const cls = circlularIcon ? ['playlist-add playlist-add__circular'] : ['playlist-add']
    if (reverse) cls.push('playlist-add--reverse')
    if (notext) cls.push('playlist-add--notext')
    if (className) cls.push(className)
    return cls.join(' ')
  }

  updatePlaylistItem (type, add, contentId, name, contentTitle) {
    const { props } = this
    const { updatePlaylistItem, setDefaultGa4Event, ga4EventData = {} } = props
    const ga4PlaylistOptions = [PLAYLIST_TYPE_DEFAULT, PLAYLIST_TYPE_FAVORITES].includes(type)
      ? { playlist_type: name }
      : { playlist_name: name, playlist_type: 'Custom' }

    if (add) {
      // GA4 event
      setDefaultGa4Event(ADDED_TO_PLAY_LIST_GA4_EVENT
        .mergeDeep(ga4PlaylistOptions)
        .mergeDeep(ga4EventData))
    } else {
      // GA4 event
      setDefaultGa4Event(REMOVED_FROM_PLAY_LIST_GA4_EVENT
        .mergeDeep(ga4PlaylistOptions)
        .mergeDeep(ga4EventData))
    }
    updatePlaylistItem({
      contentTitle,
      contentId,
      name,
      type,
      add,
    })
  }

  openUserPlaylistsModal () {
    const { props, onReturnFocus, onModalSelect } = this
    const {
      staticText, renderModal, contentId, contentTitle, uniqueId, hasPortal, ga4EventData = {},
    } = props
    renderModal(TYPE_USER_PLAYLIST_ADD, {
      onSelect: onModalSelect,
      hasPortal: !!hasPortal,
      onReturnFocus,
      contentTitle,
      staticText,
      contentId,
      uniqueId,
      uiLocation: 'Manage Playlist Modal',
      uiElement: ga4EventData.ui_element,
    })
  }

  shouldShowToolTip = (hovered, props) => {
    const { contentId, hiddenContentInfo } = props
    const dataReady = hiddenContentInfo.size > 0

    if (hovered === false) {
      return this.setState({ showAddRemoveIcon: false })
    }

    if (dataReady) {
      const hideToolTip = !!hiddenContentInfo.getIn(['content']).find((el) => {
        return (el.get('contentId') === contentId)
      })
      if (hideToolTip) {
        return this.setState({ showAddRemoveIcon: false })
      }
    }
    return this.setState({ showAddRemoveIcon: true })
  }

  render () {
    const { props } = this
    const {
      error,
      circlularIcon,
      staticText,
      centerIcon,
    } = props
    const toolTipAddRemoveText = staticText.getIn(['data', 'addToPlaylist'])

    return (
      <div
        className={this.getClass()}
        ref={this.onRef}
      >
        { circlularIcon
          ? <span className={centerIcon ? 'playlist-add__circular--add-remove' : null}>
            {
              this.props.toolTipEnabled ? <ToolTip
                visible
                containerClassName={['tool-tip__inner--add-remove']}
                className={['tool-tip__outer tool-tip__outer--add-remove']}
                arrowClassName={['tool-tip__arrow--center-bottom']}
              > { toolTipAddRemoveText }
              </ToolTip>
                : null
            }
            <Button
              className="playlist-add__cta button--with-icon playlist-add__cta--add-remove"
              onClick={this.onClick}
              type={TYPES.ICON}
              icon={ICON_TYPES.CIRCULAR_ADD}
              disabled={error}
            >
              {this.getLabel()}
            </Button>
          </span>
          : <Button
              className="playlist-add__cta"
              onClick={this.onClick}
              type={TYPES.GHOST}
              disabled={error}
            >
              {this.getLabel()}
            </Button>
        }
      </div>
    )
  }
}

PlaylistAddRemove.propTypes = {
  staticText: ImmutablePropTypes.map.isRequired,
  upstreamContext: ImmutablePropTypes.map,
  uniqueId: PropTypes.string.isRequired,
  className: PropTypes.string,
  reverse: PropTypes.bool,
  notext: PropTypes.bool,
  contentId: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]).isRequired,
  contentTitle: PropTypes.string,
  ga4EventData: PropTypes.object,
}

export default compose(
  UniqueId('playlist-add'),
  connectRedux(
    (state, { contentId }) => {
      const {
        user, playlist, staticText: text, hiddenContentPreferences,
      } = state
      const staticText = text.getIn(['data', 'playlistAddRemove'], Map())
      const error = playlist.getIn(['items', contentId, 'error'], false)
      const hasPortal = user.getIn(['data', 'portal', 'url'], '')
      const hiddenContentInfo = hiddenContentPreferences
      return {
        staticText, hasPortal, error, hiddenContentInfo,
      }
    },
    (dispatch) => {
      const actions = getBoundActions(dispatch)
      return {
        updatePlaylistItem: actions.playlist.updatePlaylistItem,
        dismissModal: actions.dialog.dismissModal,
        renderModal: actions.dialog.renderModal,
        setDefaultGa4Event: actions.eventTracking.setDefaultGa4Event,
      }
    },
  ),
)(PlaylistAddRemove)
